import Amplify, {Auth} from "aws-amplify";
const image2base64 = require("image-to-base64");

let apiName = process.env.REACT_APP_APINAME;
let endpoint = process.env.REACT_APP_ENDPOINT;

Amplify.configure({
    API: {
        endpoints: [
            {
                name: apiName,
                endpoint: endpoint,
                custom_header: async () => {
                    return {Authorization: (await Auth.currentSession()).idToken.jwtToken};
                }
            }
        ]
    },
});

class DirectpayService {

    fileUpload(userID, picture, cb){
        let url = process.env.REACT_APP_ENDPOINT+process.env.REACT_APP_URL_FILE_UPLOAD_GET;
        fetch(url,
            {
                method: "post",
                headers: {
                    "Accept": "application/json, text/plain, */*",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    folderName: "ProfileImage",
                    fileName: userID+".jpg",
                    option: 0
                })
            })
            .then(function(res){ return res.json(); })
            .then(function(data){
                if (data.status === 200) {
                    let uploadUrl = data.data.urls;
                    fetch(uploadUrl, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: picture
                    })
                        .then(function(res){ cb(null,{status:res.status}); });
                }
            }).catch(err => cb(err, null));
    }

    getUploadFile(param, cb) {
        let url = process.env.REACT_APP_ENDPOINT+process.env.REACT_APP_URL_FILE_UPLOAD_GET;
        fetch(
            url,
            {
                method: "post",
                headers: {
                    "Accept": "application/json, text/plain, */*",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(param)
            })
            .then(function(res){ return res.json(); })
            .then(function(data){
                //cb(null, data.data.urls);
                let imgUrl = data.data.urls;
                let http = new XMLHttpRequest();
                http.open("GET", imgUrl, false);
                http.send();
                if (http.status === 200){
                    image2base64(data.data.urls[0]) // you can also to use url
                        .then((response) => {
                            //console.log(response); //cGF0aC90by9maWxlLmpwZw==
                            cb(null, "data:image/png;base64, "+response);
                        })
                        .catch((error) => {
                            console.log(error); //Exepection error....
                            cb(null, "");
                        });
                    //cb(null, data.data.urls);
                }else {
                    cb(null, "");
                }
            }).catch(err => cb(err, null));
    }
}

export default DirectpayService;